import { styled } from '@mui/material/styles';
import type { ReactNode } from 'react';

const Wrapper = styled('li')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(1),
}));
const NumberText = styled('span')(() => ({
  fontVariantNumeric: 'tabular-nums',
}));

interface Props {
  label: ReactNode;
  value: string;
}

export function TooltipListItem({ label, value }: Props) {
  return (
    <Wrapper>
      {label}
      <NumberText>{value}</NumberText>
    </Wrapper>
  );
}
